module.exports = __webpack_public_path__ + "img/sela-main-title.11d4d93c.png";